<template>
  <div>

    <template>
      <mdb-container>
        <mdb-modal
          :show="confirmar"
          @close="confirmar = false"
          size="sm"
          class="text-center"
          style="top:40px;"
          danger
        >
          <mdb-modal-header center :close="false">
            <p class="heading">Confirmar que quieres eliminar el Adset {{adSetSelected.name}}</p>
          </mdb-modal-header>
          <mdb-modal-body>
            <mdb-icon icon="times" size="4x" class="animated rotateIn" />
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="eliminar()">Si</mdb-btn>
            <mdb-btn color="danger" @click="confirmar = false">No</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </mdb-container>
    </template>

    


    <b-card>

      
      <modals-container v-model="items" />

      <div class="row">

        <template>
        <mdb-modal class="modal-contenedor" :show="modal" @close="modal = false" fullHeight info removeBackdrop>
          <mdb-modal-header center :close="false">
            <p class="heading lead">{{ modalName}}</p>
          </mdb-modal-header>
          <mdb-modal-body class="modal-body">
             <modal-create-adset
            :onClick="closeModalCreate"
            v-if="modalName=='Crear'"
            ></modal-create-adset>
            <modal-edit-adset
            :onClick="closeModalCreate"
            :adset="adsetSelected"
            v-if="modalName=='Editar'"
            ></modal-edit-adset>
          </mdb-modal-body>
          <mdb-modal-footer center>
            <mdb-btn outline="danger" @click="modal = false">Cancelar</mdb-btn>
          </mdb-modal-footer>
        </mdb-modal>
      </template>
        


        <div class="col-3">
           <b-btn variant="primary" class="p-2 mb-4"  @click="openModal('Crear')">
            <i class="far fa-edit mr-1"></i>
            Nueva Ad set
          </b-btn>
        </div>

        <div class="col-4 offset-4">
           <div class="form-group">
              <label class="typo__label mr-2">
                Buscar por campaña
              </label>
              <multiselect
                v-model="campaign_selected"
                :options="campaigns"
                :multiple="false"
                 @select="getFiltroCompaign"
                :preserve-search="true"
                placeholder="Selecciona una campaña"
                label="name"
                track-by="id"
              ></multiselect>
            </div>
        </div>
      </div>
      
      <div slot="header" v-html="caption"></div>

      
      <b-table
        :dark="dark"
        :hover="hover"
        :striped="striped"
        :bordered="bordered"
        :small="small"
        :fixed="fixed"
        responsive="sm"
        :items="items"
        :fields="captions"
        :current-page="currentPage"
        :per-page="perPage"
      >
        

       <template slot="acciones" slot-scope="data">
          <b-row>
            <mdb-dropdown>
              <mdb-dropdown-toggle slot="toggle" outline="primary">Acciones</mdb-dropdown-toggle>
              <mdb-dropdown-menu>
                <mdb-dropdown-item class="mb-2" style="background: #4285f4; color:#fff;"  @click="selectAdsetEdit(data.item,items)">
                  <i class="far fa-edit mr-1 pl-1" style="color:#fff" ></i>Editar
                </mdb-dropdown-item>
                <mdb-dropdown-item  class="mb-2" style="background: #ff3547; color:#fff;" @click="selectAdsetDelete(data.item)" >
                    <i class="far fa-trash-alt mr-1 pl-1" style="color:#fff"></i>Eliminar
                </mdb-dropdown-item>
                <div class="dropdown-divider"></div>
                <mdb-dropdown-item class="mb-2 " style="background: #00c851; color:#fff;"  >
                  Actualizar remoto
                </mdb-dropdown-item>
              </mdb-dropdown-menu>
            </mdb-dropdown>
          </b-row>
        </template>

      </b-table>
      <nav>
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          prev-text="Prev"
          next-text="Next"
          hide-goto-end-buttons
        />
      </nav>
    </b-card>
  </div>
</template>

<script>
import store from "../../store";
import Multiselect from "vue-multiselect";
import { SemipolarSpinner } from "epic-spinners";
import ModalCreateAdset from "../notifications/ModalCreateAdset";
import ModalEditAdset from "../notifications/ModalEditAdset";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
} from "mdbvue";
export default {
  name: "table-partners",
  inheritAttrs: false,
  components: {
    mdbContainer,
    SemipolarSpinner,
    mdbModal,
    mdbModalBody,
    mdbModalHeader,
    mdbModalFooter,
    mdbRow,
    mdbBtn,
    mdbIcon,
    mdbTextarea,
    mdbInput,
    Multiselect,
    ModalCreateAdset,
    ModalEditAdset,
    mdbDropdown,
  mdbDropdownItem,
  mdbDropdownMenu,
  mdbDropdownToggle
  },
  props: {
    caption: {
      type: String,
      default: "Table"
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: [Array, Function],
      default: () => []
    },
    fields: {
      type: [Array, Object],
      default: () => []
    },
    perPage: {
      type: Number,
      default: 5
    },
    dark: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      currentPage: 1,
      modalCreate: false,
      modal: false,
      isLoadingLine: false,
      adSetSelected:{},
      campaigns:[],
      campaign_selected:{id:"todos",name:"Todos"},
      id: "",
      nameLine: "",
      descriptionLine: "",
      modalName: "",
      confirmar: false,
      codPostalSelected: {}
    };
  },
  computed: {
    items: function() {
      const items = this.tableData;
      return Array.isArray(items) ? items : items();
    },
    totalRows: function() {
      return this.getRowCount();
    },
    captions: function() {
      return this.fields;
    }
  },
  mounted(){
    this.getCampaignAdset()
  },
  methods: {
    getCampaignAdset(){
      var campaigns = store.getters.getCampaignAdsets;
      campaigns.unshift({id:"todos",name:"Todos"});
      this.campaigns = campaigns
    },
    getBadge(status) {
      return status === "Active"
        ? "success"
        : status === "Inactive"
        ? "secondary"
        : status === "Pending"
        ? "warning"
        : status === "Banned"
        ? "danger"
        : "primary";
    },
    getRowCount: function() {
      return this.items.length;
    },
    isTrueSelect(acciones) {
      if (acciones) {
        return true;
      }
      return false;
    },
    selectAdsetEdit(item, items) {
      this.adsetSelected = item;
      this.modalName = "Editar";
      this.modal = true;
    },
    selectAdsetDelete(item) {
      this.adsetSelected = item;
      this.modalName = "Eliminar";
      this.confirmar = true;
    },
    openModal(etapa) {
      if (etapa == "Crear") {
        this.nameLine = "";
        this.descriptionLine = "";
      }
      this.modalName = etapa;
      this.modal = true;
    },
    closeModalCreate() {
      this.modal = false;
    },
    async getFiltroCompaign(opcion){
      var campaign_id = opcion.id;
      await store.dispatch("getFiltroCompaign",campaign_id)
    },
    eliminar() {
      setTimeout(() => {
        store.dispatch("deleteAdsets", this.adsetSelected.id);
      }, 400);
      store.dispatch("deleteAdsetsUtility", this.adsetSelected.id);
      this.confirmar = false;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.badge {
  cursor: pointer;
}
.modal-body {
  overflow-y: auto;
  height: 400px;
  padding-top: 100px !important;
}

.modal-contenedor{
  top: 50px;
}
</style>
